import { fork, put, all, takeLatest, takeEvery } from "redux-saga/effects";

import {
  fetchAccounts,
  fetchAccount,
  setList,
  setItem,
  updateItem,
  addItem,
  createAccount,
  updateAccount,
  setAccountActiveFlag,
  accountsOperationPaths,
} from "../store/accountsSlice";
import { startLoading, setError, setSuccess } from "../store/appSlice";

import { push } from "connected-react-router";

import { callApi } from "./helpers/api";
import * as AccountsApi from "../api/Accounts";

function* fetchAccountsSaga() {
  const { listing: operationPath } = accountsOperationPaths();

  yield put(startLoading(operationPath));
  try {
    const data = yield callApi(AccountsApi.getAccounts, {});
    yield put(setList(data));
    yield put(setSuccess(operationPath));
  } catch (error) {
    console.error(error);
    yield put(
      setError({
        path: operationPath,
        error,
      })
    );
  }
}

function* fetchAccountSaga({ payload } = {}) {
  const { id } = payload;

  const { details: operationPath } = accountsOperationPaths(id);

  yield put(startLoading(operationPath));

  try {
    const item = yield callApi(AccountsApi.getAccount, id);
    yield put(
      setItem({
        id,
        item,
      })
    );
    yield put(setSuccess(operationPath));
  } catch (error) {
    console.error(error);
    yield put(
      setError({
        path: operationPath,
        error,
      })
    );
  }
}

function* createAccountSaga({ payload }) {
  const data = payload;

  const { create: operationPath } = accountsOperationPaths();

  yield put(startLoading(operationPath));
  try {
    const account = yield callApi(AccountsApi.postAccount, { ...data });
    yield put(addItem(account));
    yield put(setSuccess(operationPath));
    yield put(push(`/configuration/accounts/${account.id}`));
  } catch (error) {
    console.error(error);
    yield put(
      setError({
        path: operationPath,
        error,
      })
    );
  }
}

function* updateAccountSaga({ payload }) {
  const { data, id } = payload;

  const { update: operationPath } = accountsOperationPaths(id);

  yield put(startLoading(operationPath));
  try {
    const account = yield callApi(AccountsApi.patchAccount, id, data);
    yield put(setItem({ id, item: account }));
    yield put(setSuccess(operationPath));
    yield put(push(`/configuration/accounts/${account.id}`));
  } catch (error) {
    console.error(error);
    yield put(
      setError({
        path: operationPath,
        error,
      })
    );
  }
}

function* setAccountActiveFlagSaga({ payload }) {
  const { id, data } = payload;

  const { setActiveFlag: operationPath } = accountsOperationPaths(id);

  yield put(startLoading(operationPath));
  try {
    const account = yield callApi(AccountsApi.patchAccount, id, data);
    yield put(updateItem({ id, itemPart: { active: account.active } }));
    yield put(setSuccess(operationPath));
  } catch (error) {
    console.error(error);
    yield put(
      setError({
        path: operationPath,
        error,
      })
    );
  }
}

function* watchFetchAccounts() {
  yield takeLatest(fetchAccounts().type, fetchAccountsSaga);
}

function* watchFetchAccount() {
  yield takeLatest(fetchAccount().type, fetchAccountSaga);
}

function* watchCreateAccount() {
  yield takeEvery(createAccount().type, createAccountSaga);
}

function* watchUpdateAccount() {
  yield takeEvery(updateAccount().type, updateAccountSaga);
}

function* watchSetAccountActiveFlag() {
  yield takeLatest(setAccountActiveFlag().type, setAccountActiveFlagSaga);
}

export default function* rootSaga() {
  yield all([fork(watchFetchAccounts)]);
  yield all([fork(watchFetchAccount)]);
  yield all([fork(watchCreateAccount)]);
  yield all([fork(watchUpdateAccount)]);
  yield all([fork(watchSetAccountActiveFlag)]);
}
